export default [
  "base",
  "baseAlt",
  "surfaceContainerVariant",
  "accent",
  "primary",
  "accentAlt",
  "primaryContainer",
  "warning",
  "warningAlt",
  "warningContainer",
  "error",
  "errorAlt",
  "errorContainer",
  "success",
  "successAlt",
  "successContainer",
  "connect",
  "connectAlt",
  "keyExchange",
  "keyExchangeAlt",
  "disabled",
  "onSurfaceDisabled",
  "disabledAlt",
  "info",
  "infoAlt",
  "tertiaryContainer",
  "driver",
  "driverAlt",
  "owner",
  "ownerAlt",
  "onTertiaryContainer",
  "surface"
]
;